import type { ComponentPropsWithRef } from 'react'

export const TextLink: React.FC<ComponentPropsWithRef<'a'>> = (props) => {
  const isRelative = Boolean(props.href && !props.href.startsWith('http'))

  return (
    <a
      className="text-interactive font-circular-medium hover:text-blue-400"
      target={
        props.target !== undefined
          ? props.target
          : // eslint-disable-next-line sonarjs/no-nested-conditional
            isRelative
            ? '_self'
            : '_blank'
      }
      {...props}
    />
  )
}
